<template>
  <div class="container">
    <h4 class="cardD">Validar domicilio de entrega</h4>

    <div>
      <form @change="getAddressInMap(null)" @submit.prevent="sendAllChecksPassed">
        <ValidationObserver v-slot="{ handleSubmit }">
          <ModalDomicilio :currentDomicilio="currentDomicilio" @submit.prevent="handleSubmit" />
        </ValidationObserver>
      </form>
    </div>
  </div>
</template>

<script>
import ModalDomicilio from "@/views/clients/procesos/cotejo/ModalDomicilio.vue";

import { getGoogleMapUrl } from "@/utils/google-maps-utils";

export default {
  name: "Domicilio",

  components: {
    ModalDomicilio,
  },

  props: {
    cotejo: { type: Object },
  },

  data: () => ({
    currentDomicilio: {
      tieneExtranjero: false,
      tieneTipo: false,
      compareciente: false,
      extranjero: null,
      ratificacion: true,
      disabled: false,
      lat: 19.4320605,
      lng: -99.1335938,
    },
  }),

  created() {
    this.currentDomicilio = this.cotejo.domicilio;

    const submitBtns = document.getElementsByClassName("btn");
    const submitBtn = submitBtns[submitBtns.length - 1];

    if (this.cotejo.validaDomicilio || (!this.cotejo.staff && [15, 16].includes(!this.cotejo.id_estatus))) {
      this.currentDomicilio.disabled = true;
      submitBtn.disabled = true;
    }

    if (this.cotejo.staff) {
      this.currentDomicilio.staff = true;
    }
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async getAddressInMap() {
      const address = `${this.currentDomicilio.calle}, ${this.currentDomicilio.num_exterior}, ${this.currentDomicilio.colonia},
        ${this.currentDomicilio.delegacion_municipio}, ${this.currentDomicilio.codigo_postal},
        ${this.currentDomicilio.ciudad}, ${this.currentDomicilio.entidad}`;

      const mapUrl = await getGoogleMapUrl(address);
      if (mapUrl === null) {
        return;
      }

      this.$set(this.currentDomicilio, "lat", mapUrl.lat.toString());
      this.$set(this.currentDomicilio, "lng", mapUrl.lng.toString());
    },

    sendAllChecksPassed() {
      const camposValidos = ["calle", "num_exterior", "colonia", "delegacion_municipio", "entidad", "pais", "codigo_postal"];

      if (!this.cotejo.staff) {
        // camposValidos.push('validacionDatos');
      }

      const camposCompletos = camposValidos.every((campo) => this.currentDomicilio[campo]);

      if (!camposCompletos) {
        this.showErrorToast("Por favor ingresa todos los campos");

        return;
      }

      this.cotejo.domicilio = this.currentDomicilio;
      this.currentDomicilio.disabled = true;
      const submitBtns = document.getElementsByClassName("btn");
      const submitBtn = submitBtns[submitBtns.length - 1];
      submitBtn.disabled = true;
      this.$emit("allChecksPassed");
    },
  },
};
</script>
